<template>
  <div class="cert-focus-item row mx-0 py-3" :class="separator?'cert-b-bottom':''">
    <div class="col-12 col-sm-4 cert-title">{{ title }}</div>
    <div class="col-12 col-sm-4 cert-text">{{ description }}</div>
    <div class="col-12 col-sm-4 d-flex">
      <div class="ml-auto d-none d-sm-block"></div>
      <div @click="url!=null?onClickExternal():onClickLocal()" class="mt-2 my-sm-auto cert-btn-strong cer-outline"
           style="margin-left: 0">
        {{ buttonText }}
      </div>
      <a v-if="url!=null" :ref="title" target="_blank" :href="'//'+url" style="display: none"></a>
    </div>
  </div>
</template>

<script>

export default {
  name: "CertLawContainer",
  props: {
    title: String,
    description: String,
    url: String,
    path: String,
    buttonText: {
      type: String,
      default: "Download",
    },
    separator: {
      type: Boolean,
      default: true,
    },
    preDownload: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    async onClickExternal() {
      if (!this.preDownload) {
        let el = this.$refs[this.title];
        el.click();
        return;
      }
      window.open(this.url, "_blank");
    },
    onClickLocal() {
      this.$router.push({path: this.path});
    }
  }
}
</script>